import type { User, Visitor } from '../api/types';

const COLOR_KEY = 'visitor-color';

function randomColor(): string {
  return `#${Math.floor(Math.random() * 0xffffff)
    .toString(16)
    .padStart(6, '0')}`;
}

export class VisitorService {
  private visitor?: Visitor;

  init(user: User): Visitor {
    const storedColor = sessionStorage.getItem(COLOR_KEY);
    const color = storedColor ?? randomColor();
    if (!storedColor) sessionStorage.setItem(COLOR_KEY, color);

    const v: Visitor = {
      id: user.id,
      name: user.name,
      color,
    };
    this.visitor = v;
    return v;
  }

  get(): Visitor {
    if (!this.visitor) {
      throw new Error('Visitor not initialized');
    }
    return this.visitor;
  }
}

export const visitorService = new VisitorService();
